const useHeadProperties = {
  title: "J'agis",
  titleTemplate: "%s - J'agis",
};

export default useHeadProperties;
